import React from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { useParams } from "react-router-dom";

import Login from "./Login/Login";
import Signup from "./Signup/Signup";

const Auth = (props) => {
  let { page } = useParams();
  let redirect = null;
  if (props.isLoggedIn) {
    redirect = <Redirect to="/" />;
  }
  return (
    <div className="Auth">
      {redirect}
      <section>{page === "signup" ? <Signup /> : <Login />}</section>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    isLoggedIn: state.userId !== null,
  };
};

export default connect(mapStateToProps)(Auth);
